export default __webpack_public_path__ + "static/media/Path 96.3b76d16e.svg";